module.exports = __webpack_public_path__ + "img/404.ba788f00.png";